import { Step } from "react-joyride";

const trialUserOrganizationSettingsTourSteps: Step[] = [
  {
    target: ".tour-choose-logo",
    content: "Choose a logo for your company. Must be a JPEG or PNG file.",
    skipScroll: true,
    overlayClickAction: false,
    dismissKeyAction: false,
  },
  {
    target: ".tour-organization-phone-email",
    content: "Enter your Organization’s phone number.",
    placement: "right",
    overlayClickAction: false,
    dismissKeyAction: false,
    buttons: ["back", "close", "primary"],
  },
  {
    target: ".tour-organization-timezone",
    content: "Select the timezone you are in.",
    placement: "top",
    overlayClickAction: false,
    dismissKeyAction: false,
    buttons: ["back", "close", "primary"],
  },
  {
    target: ".tour-organization-sales-goal",
    content: "Now create a yearly sales goal for your company. Enter a sales goal dollar amount.",
    placement: "right",
    buttons: ["back", "close", "primary"],
  },
  {
    target: ".tour-modal-address-line1",
    content: "Enter your Organization's Address",
    buttons: ["close"],
    overlayClickAction: false,
    dismissKeyAction: false,
  },
];

export default trialUserOrganizationSettingsTourSteps;
